<script>
    import _ from 'lodash'

    export default {
        props: {
            debounce: {
                type: Number,
                default: 250
            },
            scrollToBottomOnCreated: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                top: 0,
                bottom: 0
            }
        },
        mounted () {
            this.top = this.$el.scrollTop

            this.$el.addEventListener('scroll', _.debounce(e => {
                this.update()
            }, this.debounce))

            if (this.scrollToBottomOnCreated) this.scrollToBottom()
        },
        methods: {
            update () {
                this.top = this.$el.scrollTop
                this.bottom = this.$el.scrollHeight - (this.$el.offsetHeight + this.$el.scrollTop)

                this.$emit('scroll', {
                    top: this.top,
                    bottom: this.bottom
                })
            },
            dontMove (callback) {
                this.update()

                const bottom = this.bottom

                callback()

                this.$nextTick(() => {
                    this.$el.scrollTop = this.$el.scrollHeight - this.$el.offsetHeight - bottom

                    this.update()
                })
            },
            scrollToBottom () {
                this.$nextTick(() => {
                    this.$el.scrollTop = this.$el.scrollHeight - this.$el.offsetHeight
                })
            }
        },
        render () {
            return this.$scopedSlots.default({
                top: this.top,
                bottom: this.bottom,
                scrollToBottom: this.scrollToBottom
            })
        }
    }
</script>
